import { ParameterTypeEnum } from "src/app/enums/parameterType.enum";

export const ConcentrationParameterTypes = [
    ParameterTypeEnum.Pm1,
    ParameterTypeEnum.Pm2_5,
    ParameterTypeEnum.Pm10,
    ParameterTypeEnum.RespirablePm,
    ParameterTypeEnum.BinMass,
    ParameterTypeEnum.MeasuredRCS,
];

export const GasParameterTypes = [
    ParameterTypeEnum.Ozone,
    ParameterTypeEnum.SO2,
    ParameterTypeEnum.NO2,
    ParameterTypeEnum.CO,
    ParameterTypeEnum.CO2,
    ParameterTypeEnum.TVOC,
    ParameterTypeEnum.H2S,
    ParameterTypeEnum.NO,
];
